import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from 'react-redux-form';
import { CustomDropdown } from '../../../../../common/custom-form/custom-dropdown.component';
import "./ApproverDetails.css";
import { InputFieldFloatingLabel as InputField } from '../../../../../common/custom-form/select-filter.component';
import { MAX_LENGTH, WIRELINE_REQUEST_TYPES_ID } from "../../../../../../constants/external-constants";
import { orderDetailsActions } from '../../../../../../store/external/order/order-details.reducer';

class ApproverDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDropDown: false            
        }
    }
    handleToggle = () =>{
        this.setState(prev => ({isDropDown: !prev.isDropDown}))
    }

    render() {
        const { translator, orderDetails, orderDetailsForm, requestTypeId } = this.props;
        const { isDropDown } = this.state;

        return (
            <div className="approver_details_container control-container">
                <CustomDropdown activeDropdown={isDropDown} toggleActiveState={() => this.handleToggle()} label={translator("approver_details_lc")} >
                <div className={`add-sim-container detail-page-container`}>
                    <label className="approver-details-row-label">{Object.values(WIRELINE_REQUEST_TYPES_ID).includes(requestTypeId) ? 'Approver' : 'Cost Code Approver'}</label>
                        {
                            Object.values(WIRELINE_REQUEST_TYPES_ID).includes(requestTypeId) ? (
                                <div className="approver-details-row">
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={translator("wireline_approver_name")}
                                        value={orderDetailsForm.wirelineApproverName}
                                        fieldProp='orderDetailsForm.wirelineApproverName'
                                        maxLength={MAX_LENGTH.limit_100}
                                        disabled={true}

                                    />
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={translator("wireline_approver_email")}
                                        value={orderDetailsForm.wirelineApproverEmail}
                                        fieldProp='orderDetailsForm.wirelineApproverEmail'
                                        maxLength={MAX_LENGTH.limit_100}
                                        disabled={true}

                                    />
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={translator("wireline_approved_date")}
                                        value={orderDetailsForm.wirelineApproverEmail == orderDetailsForm.AuditUserId ? orderDetailsForm.wirelineApprovedDate : null}
                                        fieldProp='orderDetailsForm.wirelineApprovedDate'
                                        maxLength={MAX_LENGTH.limit_100}
                                        disabled={true}

                                    />
                                </div>)
                                :
                                (
                                    <div className="approver-details-row">
                                        <InputField
                                            className="form-control"
                                            type="text"
                                            label={translator("cost_code_approver_name")}
                                            value={orderDetailsForm.costCodeApproverName}
                                            fieldProp='orderDetailsForm.costCodeApproverName'
                                            maxLength={MAX_LENGTH.limit_100}
                                            disabled={true}

                                        />
                                        <InputField
                                            className="form-control"
                                            type="text"
                                            label={translator("cost_code_approver_email")}
                                            value={orderDetailsForm.costCodeApproverEmail}
                                            fieldProp='orderDetailsForm.costCodeApproverEmail'
                                            maxLength={MAX_LENGTH.limit_100}
                                            disabled={true}

                                        />
                                        <InputField
                                            className="form-control"
                                            type="text"
                                            label={translator("cost_code_approved_date")}
                                            value={orderDetailsForm.costCodeApproverEmail == orderDetailsForm.AuditUserId ? orderDetailsForm.costCodeApprovedDate : null}
                                            fieldProp='orderDetailsForm.costCodeApprovedDate'
                                            maxLength={MAX_LENGTH.limit_100}
                                            disabled={true}

                                        />
                                    </div>)

                        }

                    <label className="approver-details-row-label">Line Manager</label>

                    <div className="approver-details-row">

                        <InputField
                            className="form-control"
                            type="text"
                            label={translator("line_manager_name")}
                            value={orderDetailsForm.lineManagerName}
                            fieldProp='orderDetailsForm.lineManagerName'
                            maxLength={MAX_LENGTH.limit_100}
                            disabled={true}

                        />
                        <InputField
                            className="form-control"
                            type="text"
                            label={translator("line_manager_email")}
                            value={orderDetailsForm.lineManagerEmail}
                            fieldProp='orderDetailsForm.lineManagerEmail'
                            maxLength={MAX_LENGTH.limit_100}
                            disabled={true}

                        />
                        <InputField
                            className="form-control"
                            type="text"
                            label={translator("line_manager_approved_date")}
                            value={orderDetailsForm.lineManagerApprovedDate}
                            fieldProp='orderDetailsForm.lineManagerApprovedDate'
                            maxLength={MAX_LENGTH.limit_100}
                            disabled={true}

                        />
                       
                    </div>
                    <label className="approver-details-row-label">2nd Line Manager</label>

                    <div className="approver-details-row">
                        <InputField
                            className="form-control"
                            type="text"
                            label={translator("second_line_manager_name")}
                            value={orderDetailsForm.secondLineManagerName}
                            fieldProp='orderDetailsForm.secondLineManagerName'
                            maxLength={MAX_LENGTH.limit_100}
                            disabled={true}
                        />
                        <InputField
                            className="form-control"
                            type="text"
                            label={translator("second_line_manager_email")}
                            value={orderDetailsForm.secondLineManagerEmail}
                            fieldProp='orderDetailsForm.secondLineManagerEmail'
                            maxLength={MAX_LENGTH.limit_100}
                            disabled={true}

                        />
                        <InputField
                            className="form-control"
                            type="text"
                            label={translator("second_line_manager_approved_date")}
                            value={orderDetailsForm.secondLineManagerApprovedDate}
                            fieldProp='orderDetailsForm.secondLineManagerApprovedDate'
                            maxLength={MAX_LENGTH.limit_100}
                            disabled={true}

                        />
                    </div>
                    
                   

                     
                </div>
                </CustomDropdown>
                
            </div>
        );
    }
}


export default connect(
    state => {
        const { orderDetails, translation } = state;
        const { orderDetailsForm } = state.form;
        return {
            orderDetails,
            orderDetailsForm,
            ...translation,
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, orderDetailsActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
    })
)(ApproverDetails);